const _ = require("lodash");

// Source: https://gitlab.com/tailormed/vivor/monorepo/-/blob/development/utils/lib/npiHelper.js?ref_type=heads
exports.npiValidator = function (npi) {
  if (!npi || npi.length !== 10) return false;
  let digits = npi.split("");
  digits = digits.map((digit) => parseInt(digit));
  const checkDigit = digits[9];
  let singleDigits = [digits[1], digits[3], digits[5], digits[7]];
  const doubleDigits = [digits[0], digits[2], digits[4], digits[6], digits[8]];
  _.forEach(doubleDigits, (digit) => {
    digit = digit * 2;
    singleDigits = _.concat(
      singleDigits,
      String(digit)
        .split("")
        .map((digit) => parseInt(digit))
    );
  });
  const sum = 24 + _.sum(singleDigits);
  const next10 = Math.ceil(sum / 10) * 10;
  return Boolean(next10 - sum === checkDigit);
};
